import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { IGetCheckListModel } from 'src/app/model/checkList.model';
import { CheckListService } from '../check-list-service.service';

@Component({
  selector: 'app-check-list-details',
  templateUrl: './check-list-details.component.html',
  styleUrls: ['./check-list-details.component.css']
})
export class CheckListDetailsComponent implements OnInit {

  public checkListForm: UntypedFormGroup;
  public user: any;
  public checklistItemsToUpdate = [];

  constructor(
    private _checkListService: CheckListService, @Inject(MAT_DIALOG_DATA) public checkListData: IGetCheckListModel,
    private _fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public currentBusinessUnitId: string, private _toastr: ToastrService
  ) { }
  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.generateCheckListForm();
    this.getCheckListDetails();
  }

  public generateCheckListForm() {
    this.checkListForm = this._fb.group({
      checkListItems: this._fb.array([])
    })
  }

  get checkListItems() {
    return this.checkListForm.get("checkListItems") as UntypedFormArray;
  }

  getCheckListDetails(updatedChekList?) {
    this._checkListService.getCheckListBySR(this.checkListData, updatedChekList == undefined ? [] : updatedChekList, updatedChekList == undefined ? "00000000-0000-0000-0000-000000000000" : this.user.memberId,).subscribe((response) => {
      if (response.data != null) {
        if (updatedChekList) {
          this._toastr.success("CheckList Updated Successfully.", "Success", { timeOut: 2000, positionClass: "toast-top-center" });
        }
        this.generateCheckListForm();
        if (response.data.checkListItemForSpecifiedServiceType.length != 0) {
          this.setCheckListForm(response.data.checkListItemForSpecifiedServiceType);
        }
      }
    },
      (error) => {
        console.log(error);
        this._toastr.warning('Something went wrong while getting cheklist!', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
      })
  }

  setCheckListForm(checklistData) {
    this.addNewCheckListItem(checklistData);
  }

  addNewCheckListItem(checklistData?) {
    checklistData.forEach(checkListItem => {
      let newItemGroup = this._fb.group({
        itemName: checkListItem.checkListItemName,
        itemValues: this._fb.group({
          createdBy: checkListItem.createdBy,
          createdOn: checkListItem.createdOn,
          isChecked: checkListItem.isChecked,
          lastUpdatedBy: checkListItem.lastUpdatedBy,
          lastUpdatedByName: checkListItem.lastUpdatedByName,
          lastUpdatedOn: checkListItem.lastUpdatedOn
        })
      })
      if (this.user.role != "Coordinator" && this.user.role != "Management" && this.user.role != "Executive Admin") {
        newItemGroup.disable();
      }
      this.checkListItems.push(newItemGroup);
    })
  }

  updateCheckListItems() {
    if (this.checklistItemsToUpdate.length == 0) {
      this._toastr.warning('Please update some values to save changes!', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
    }
    else {
      this.getCheckListDetails(this.checklistItemsToUpdate)
      this.checklistItemsToUpdate = [];
    }
  }

  onCheckBoxValueChenge(index) {
    let itemIndex = this.checklistItemsToUpdate.findIndex(x => x.name == this.checkListItems.controls[index].value.itemName);
    if (itemIndex == -1) {
      let newItemGroup = {
        name: this.checkListItems.controls[index].value.itemName,
        value: {
          checkListItemName: this.checkListItems.controls[index].value.itemName,
          createdBy: this.checkListItems.controls[index].value.itemValues.createdBy,
          createdOn: this.checkListItems.controls[index].value.itemValues.createdOn,
          isChecked: this.checkListItems.controls[index].value.itemValues.isChecked,
          lastUpdatedBy: this.user.memberId,
          lastUpdatedByName: this.user.name,
          lastUpdatedOn: null,
        }
      }
      this.checklistItemsToUpdate.push(newItemGroup);
    }
    else {
      this.checklistItemsToUpdate.splice(itemIndex, 1);
    }
  }

}
